module.exports = __webpack_public_path__ + "static/boyd-40cb1971d3bcd7e521f3690892158762.png";